var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 15.5L12 8.5L19 15.5","stroke":"currentColor","strokeWidth":"2"}));
}

ArrowUp.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
